import { CartCardDescription } from "components/UI/atoms";
import { CartCardValue } from "components/UI/atoms/cart-card-value";
import "./index.scss";
import { useCartContext } from "context/cart-context";
import { useCheckoutContext } from "context/checkout-context";

export const MenuCartItem = ({ card }) => {
  const {
    cardUrl,
    cardType,
    imageAlt,
    imageSrc,
    name,
    uuid,
    value,
    price,
    brandUuid,
    listingUuid,
    userUuid
  } = card;
  const cardTypes = (cardType && cardType.cardTypes) || [];
  const { removeCard } = useCartContext();
  const { getCheckoutData } = useCheckoutContext();

  return (
    <li className={"menu-cart-item"}>
      <a className={"image-wrapper"} href={cardUrl} rel="noopener noreferrer">
        <img
          className={"image"}
          draggable="false"
          alt={imageAlt}
          src={imageSrc}
        />
      </a>
      <CartCardDescription
        name={name}
        cardUrl={cardUrl}
        cardTypes={cardTypes}
      />
      <CartCardValue value={value} price={price} />
      <button
        data-testid="remove-cart-item-button"
        data-logid="remove-cart-item-cart-menu-button"
        data-gtm="true"
        data-payload={uuid}
        type="button"
        aria-label="Remove Card"
        onClick={() => {
          removeCard({
            brandUUID: brandUuid,
            listingUUID: listingUuid,
            userID: userUuid
          });
          getCheckoutData();
        }}
        className={"remove"}
        tabIndex={0}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="presentation"
          focusable="false"
          className={"remove-svg"}
          viewBox="0 0 40 40"
        >
          <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
        </svg>
      </button>
    </li>
  );
};
